import { Alert, AlertTitle } from '@mui/material'
import { useIntl } from '@/intl'
import { useState } from 'react'

export function LoadsAlert() {
  const { alert } = useTexts()

  return (
    <Alert severity="warning">
      <AlertTitle>{alert.title}</AlertTitle>
      {alert.description}
    </Alert>
  )
}

function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    alert: {
      title: translate({ id: 'order.form.single.field.loads.alert.title' }),
      description: translate({ id: 'order.form.single.field.loads.alert.description' }),
    },
  }))

  return api
}
